import styled from 'styled-components';
import { Upload, Modal } from 'antd';
import { Card } from '@packages/utils';

export const SModal = styled(Modal)`
  .ant-modal-content {
    max-height: 650px;
    display: flex;
    flex-direction: column;
  }

  .ant-modal-body {
    max-height: calc(650px - 110px);
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 4px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
  }

  .ant-modal-header {
    flex-shrink: 0;
  }

  .ant-modal-footer {
    flex-shrink: 0;
  }
`;

export const SUploader = styled(Upload)`
  .ant-upload.ant-upload-select {
    width: 100%;
    border: 1px dashed #0077a0;
    background-color: #e9f7f7;
    border-radius: 8px;
    min-height: 104px;
    padding: 0;
  }
  .ant-upload {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 12px;
    cursor: pointer;
  }

  .ant-upload-drag-icon {
    margin: 0;
    margin-bottom: 8px;
    .anticon {
      color: #0077a0;
      font-size: 32px !important;
    }
  }

  .ant-upload-text {
    margin: 0 0 4px 0;
    font-size: 16px;
    font-weight: 500;
    color: #0077a0 !important;
  }

  .ant-upload-hint {
    margin: 0;
    font-size: 14px;
    color: #0077a0 !important;
    opacity: 0.8;
  }
`;

export const SUploadedItemWrapper = styled(Card)`
  &.ant-card {
    .ant-card-body {
      padding: 12px;
    }
  }
`;
